import { z } from 'zod'
import type { ApiClient } from '../apiClient'

export const ratioComponentFactsRowSchema = z.object({
  ratio_kpi: z.string(),
  num_fact: z.string(),
  denom_fact: z.string(),
})
export type RatioComponentFactsRow = z.infer<typeof ratioComponentFactsRowSchema>
const schema = z.array(ratioComponentFactsRowSchema)

export async function fetchRatioComponentFacts(
  client: ApiClient,
): Promise<RatioComponentFactsRow[]> {
  const raw = await client.get<unknown>('/v_ratio_component_facts')
  return schema.parse(raw)
}
